var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-detail"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.gender === 'male') ? _c('i', {
    staticClass: "fa fa-lg fa-mars icon-male",
    attrs: {
      "aria-hidden": "true",
      "title": "muž"
    }
  }) : (_vm.client.gender === 'female') ? _c('i', {
    staticClass: "fa fa-lg fa-venus icon-female",
    attrs: {
      "aria-hidden": "true",
      "title": "žena"
    }
  }) : _c('i', {
    staticClass: "fa fa-lg fa-genderless icon-genderless",
    attrs: {
      "aria-hidden": "true",
      "title": "neznámé pohlaví"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.client.full_name))])]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), (_vm.client.insurance_number !== null) ? _c('span', [_vm._v("ČP: "), _c('b', [_vm._v(_vm._s(_vm.client.insurance_number))])]) : (_vm.client.p_i_n !== false) ? _c('span', [_vm._v("RČ: "), _c('b', [_vm._v(_vm._s(_vm.client.p_i_n))])]) : _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chybí RČ / ČP")]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.client.age_with_suffix) + " (" + _vm._s(_vm.client.birth_date) + ")")]), _vm._v(" "), (_vm.client.employer) ? [_c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.client.employer))])] : _vm._e()], 2)]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(!_vm.citizenshipPending) ? _c('div', {
    staticClass: "container tooltip_container tooltip_2_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }, [(_vm.editMode === false) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-detail-edit"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" upravit")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-detail-back"
    },
    on: {
      "click": _vm.view
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" zpět")])]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Úprava klienta")]) : _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Detail klienta")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 tooltip_body text-left"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "titlesPreName"
    }
  }, [_vm._v("Tituly před jménem:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.title_before),
      expression: "clientForm.title_before"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-title-before",
      "aria-describedby": "titlesPreNameHelp",
      "id": "titlesPreName"
    },
    domProps: {
      "value": (_vm.clientForm.title_before)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.title_before = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "titlesPreNameError"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Jméno:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.first_name),
      expression: "clientForm.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-first-name",
      "aria-describedby": "firstnameHelp",
      "id": "firstname"
    },
    domProps: {
      "value": (_vm.clientForm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.first_name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.firstname) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "firstnameError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.firstname.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Příjmení:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.last_name),
      expression: "clientForm.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-last-name",
      "aria-describedby": "lastnameHelp",
      "id": "lastname"
    },
    domProps: {
      "value": (_vm.clientForm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.last_name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.lastname) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "lastnameError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.lastname.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "titlesAfterName"
    }
  }, [_vm._v("Tituly za jménem:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.title_after),
      expression: "clientForm.title_after"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-title-after",
      "aria-describedby": "titlesAfterNameHelp",
      "id": "titlesAfterName"
    },
    domProps: {
      "value": (_vm.clientForm.title_after)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.title_after = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "titlesAfterNameError"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "citizenshipGov"
    }
  }, [_vm._v("Státní příslušnost (občanství):")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.citizenship.id),
      expression: "clientForm.citizenship.id"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-detail-citizenship",
      "aria-describedby": "citizenshipGovHelp",
      "id": "citizenshipGov"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.clientForm.citizenship.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.citizenship), function(c) {
    return _c('option', {
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name_cz) + " - " + _vm._s(c.code) + " - " + _vm._s(c.name_en))])
  })), _vm._v(" "), (_vm.clientError.citizenship) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "citizenshipError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.citizenship.message))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "personalid"
    }
  }, [_vm._v("Rodné číslo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.p_i_n),
      expression: "clientForm.p_i_n"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-pin",
      "aria-describedby": "personalidHelp",
      "id": "personalid"
    },
    domProps: {
      "value": (_vm.clientForm.p_i_n)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.p_i_n = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.pin) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "personalidError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.pin.message) + " " + _vm._s(_vm.parsePinMessage))]) : _vm._e(), _vm._v(" "), (_vm.decodePinWarning !== null) ? _vm._l((_vm.decodePinWarning), function(warning, index) {
    return _c('div', [(index === 'duplicate' && warning.clients.length > 1) ? [_c('small', {
      staticClass: "form-text text-danger"
    }, [_vm._v(_vm._s(warning.text))]), _vm._v(" "), _vm._l((warning.clients), function(client) {
      return _c('small', {
        staticClass: "form-text text-danger"
      }, [_vm._v(" - " + _vm._s(client.full_name))])
    })] : (index !== 'duplicate') ? [_c('small', {
      staticClass: "form-text text-danger"
    }, [_vm._v(_vm._s(warning.text))])] : _vm._e()], 2)
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "insuranceNumber"
    }
  }, [_vm._v("Číslo pojištěnce:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.insurance_number),
      expression: "clientForm.insurance_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-insurance-number",
      "aria-describedby": "insuranceNumberHelp",
      "id": "insuranceNumber"
    },
    domProps: {
      "value": (_vm.clientForm.insurance_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.insurance_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.insurancenumber) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "insuranceNumberError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.insurancenumber.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Pohlaví:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.gender),
      expression: "clientForm.gender"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-detail-gender",
      "aria-describedby": "genderHelp",
      "id": "gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.clientForm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("muž")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("žena")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("nezjištěno")])]), _vm._v(" "), (_vm.clientError.gender) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "genderError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.gender.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "birthdate"
    }
  }, [_vm._v("Datum narození:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.birth_date),
      expression: "clientForm.birth_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-birth-date",
      "aria-describedby": "birthdateHelp",
      "id": "birthdate"
    },
    domProps: {
      "value": (_vm.clientForm.birth_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.birth_date = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.birthdate) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "birthdateError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.birthdate.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "employer"
    }
  }, [_vm._v("Zaměstnavatel/firma:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.employer),
      expression: "clientForm.employer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-employer",
      "aria-describedby": "firstnameHelp",
      "id": "employer"
    },
    domProps: {
      "value": (_vm.clientForm.employer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.employer = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.employer) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "employerError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.employer.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.decodePinPending) ? _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Čekám")]) : (_vm.clientPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "client-detail-save"
    }
  }, [_vm._v("Uložit změny")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])])]) : _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table_labeled table-bordered",
    attrs: {
      "data-testid": "client-detail-table"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "w-25"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("tituly před jménem")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.title_before)))]), _vm._v(" "), _c('td', {
    staticClass: "w-25"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("jméno")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.first_name)))]), _vm._v(" "), _c('td', {
    staticClass: "w-25"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("příjmení")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.last_name)))]), _vm._v(" "), _c('td', {
    staticClass: "w-25"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("tituly za jménem")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.title_after)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("státní příslušnost (občanství)")]), _vm._v(_vm._s(_vm.client.citizenship ? _vm.client.citizenship.name_cz : '-'))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("rodné číslo")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.p_i_n)))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("číslo pojištěnce")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.insurance_number)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("pohlaví")]), _vm._v(_vm._s(_vm._f("genderToCS")(_vm.client.gender)))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("datum narození")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.birth_date)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("zaměstnavatel/firma:")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.employer)))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  })])])])])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ed78ce","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientDetail.vue
// module id = 345
// module chunks = 0